import React, { FC, MouseEvent, ReactNode } from 'react'

import { useTheme } from 'styled-components'

import {
  LeftArrow,
  LeftArrowHref,
  RightArrow,
  RightArrowHref,
} from 'components/presentational/Arrows/Arrows.styled'
import { Arrow2Svg } from 'components/presentational/svg/Arrow2Svg'

export interface ArrowsProps {
  isShow: boolean
  isArrowLeftShow: boolean
  isArrowRightShow: boolean
  arrowLeft: ReactNode
  arrowRight: ReactNode
}

export const Arrows: FC<ArrowsProps> = ({
  isShow,
  arrowLeft,
  arrowRight,
  isArrowLeftShow,
  isArrowRightShow,
}) => {
  return isShow ? (
    <>
      {isArrowLeftShow && arrowLeft}
      {isArrowRightShow && arrowRight}
    </>
  ) : null
}

interface ArrowProps {
  href?: string
  size?: number
  height?: number
  alwaysShow?: boolean
}

export interface ArrowLeftProps extends ArrowProps {
  onMoveLeft: (event: MouseEvent) => void
}

export const ArrowLeft: FC<ArrowLeftProps> = ({
  onMoveLeft,
  href,
  size,
  height,
  alwaysShow = false,
}) => {
  const { multiplier } = useTheme()
  const rotate = 270 * multiplier

  if (href) {
    return (
      <LeftArrowHref
        to={href}
        onClick={onMoveLeft}
        data-name="arrow-left"
        size={size}
        height={height}
      >
        <Arrow2Svg rotate={rotate} />
      </LeftArrowHref>
    )
  }
  return (
    <LeftArrow
      onClick={onMoveLeft}
      data-name="arrow-left"
      size={size}
      height={height}
      $alwaysShow={alwaysShow}
    >
      <Arrow2Svg rotate={rotate} />
    </LeftArrow>
  )
}

export interface ArrowRightProps extends ArrowProps {
  onMoveRight: (event: MouseEvent) => void
}

export const ArrowRight: FC<ArrowRightProps> = ({
  onMoveRight,
  href,
  size,
  height,
  alwaysShow = false,
}) => {
  const { multiplier } = useTheme()
  const rotate = 90 * multiplier

  if (href) {
    return (
      <RightArrowHref
        to={href}
        onClick={onMoveRight}
        data-name="arrow-right"
        size={size}
        height={height}
      >
        <Arrow2Svg rotate={rotate} />
      </RightArrowHref>
    )
  }

  return (
    <RightArrow
      onClick={onMoveRight}
      data-name="arrow-right"
      size={size}
      height={height}
      $alwaysShow={alwaysShow}
    >
      <Arrow2Svg rotate={rotate} />
    </RightArrow>
  )
}
